"use client";

import React from "react";
import $filters, { Filter } from "@/data/filters.constants";
import { useMobile } from "@/hooks/use-responsive";
import Dropdown, {
  DropdownSelectorOption,
} from "@/components/pages/home/components/searchbar/components/dropdown";
import FilterButtons from "@/components/pages/home/components/searchbar/components/filter-buttons";
import { useCategoriesDropdownContext } from "@/components/pages/home/providers/categories-dropdown-provider";

export type FiltersProps = {
  onSelectFilter: (filter: Filter) => void;
  filters: Filter[];
  selectedFilter: Filter;
  displayCreateCustomVoice?: boolean;
  scrollY?: number;
};

const FiltersContainer = ({
  selectedFilter,
  onSelectFilter,
  filters,
  displayCreateCustomVoice,
  scrollY,
}: FiltersProps) => {
  const { isMobile } = useMobile();
  const { value, setValue } = useCategoriesDropdownContext();

  const handleDropdownSelect = (option?: DropdownSelectorOption) => {
    onSelectFilter(option ?? $filters.defaultModelFilter);
    setValue(option);
  };

  return isMobile ? (
    <Dropdown
      selectedOption={value}
      onSelect={handleDropdownSelect}
      items={filters}
      placeholder={"Categories"}
    />
  ) : (
    <FilterButtons
      filters={filters}
      selectedFilter={selectedFilter}
      onSelectFilter={onSelectFilter}
      displayCreateCustomVoice={displayCreateCustomVoice}
      scrollY={scrollY}
    />
  );
};

export default FiltersContainer;
